"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactComponent = SvgComponent;
exports.default = void 0;

var _pragma = require("../../pragma");

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgComponent(props) {
  return (0, _pragma.createFelaElement)("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), (0, _pragma.createFelaElement)("defs", null), (0, _pragma.createFelaElement)("path", {
    fill: "currentColor",
    d: "M21.375 9l-7.313-.562 1.079-4.191c.28-1.247-.037-1.963-1.054-2.278l-1.626-.462a.187.187 0 00-.206.08l-6.047 9.485a.375.375 0 01-.32.179H.75V21h5.513c.242 0 .482.039.712.115l3.576 1.192a3.75 3.75 0 001.186.193h8.34c.891 0 1.477-.634 1.652-1.508l1.521-6.668v-3.449c0-1.034-.844-1.781-1.875-1.875z"
  }));
}

var _default = 'src/asset/icon/upvote.icon.svg';
exports.default = _default;
//# sourceMappingURL=upvote.icon.js.map